// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"dJ-z","smallCardRow":"eJ-z","largeCardRow":"fJ-z","productSearchRow":"gJ-z","curatedRow":"hJ-z"};